import React from "react";
import "./BottomBar.css";

/**
 * Lightweight chrome footer wrapper (version strip).
 * Avoids MUI BottomNavigation so fixed positioning stays reliable on iOS.
 */
const BottomBar = ({ className = "", children, ...rest }) => (
    <footer className={["bottomNav", className].filter(Boolean).join(" ")} {...rest}>
        {children}
    </footer>
);

export default BottomBar;
